import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

export const guestVatSupportLink = `https://support.peerspace.com/${zendeskLocale}/articles/10119164-how-does-value-added-tax-vat-work-non-u-s-guests-only`;
export const hostVatSupportLink = `https://support.peerspace.com/${zendeskLocale}/articles/10119430-how-does-value-added-tax-vat-work-non-u-s-hosts-only`;
